module.exports = __webpack_public_path__ + "static/green-card-75b5e428a4aef8bc1f086b2530d045f5.svg";